import { useEffect, useState } from 'react';
import { AiGradientIconFilled } from '../../Components/AiGradientIcon';
import { AiProjectEnhancementSystem, ProjectEnhancementOptionsPayload, EnhancedProject } from '../../system/ai/AiProjectEnhancementSystem';
import { t } from 'i18next';

export enum TypeMessageEnhancement {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  RESET = 'RESET',
  WARNING = 'WARNING',
}

export type MessageEnhancement = { type: TypeMessageEnhancement; className: string; value: React.ReactNode } | null;

export function useProjectEnhancement(aiProjectEnhancementSystem: AiProjectEnhancementSystem) {
  const [originalData, setOriginalData] = useState<EnhancedProject>({ project_name: '', project_description: '' });
  const [loading, setLoading] = useState(false);
  const [wasGenerated, setWasGenerated] = useState(false);
  const [message, setMessage] = useState<MessageEnhancement>(null);

  const generateEnhancement = async (payload: ProjectEnhancementOptionsPayload, onSuccess: (result: EnhancedProject) => void) => {
    setLoading(true);
    setOriginalData(payload);
    setMessage(null);
    try {
      const response = await aiProjectEnhancementSystem.enhanceProject(payload);
      onSuccess(response);
      setWasGenerated(true);
      setMessage({
        type: TypeMessageEnhancement.SUCCESS,
        className: 'success-message-animate',
        value: (
          <div className="message-flex">
            <AiGradientIconFilled /> {t('Redacción de la proyecto mejorada con éxito')}
          </div>
        ),
      });
    } catch (err) {
      console.error(err);
      setMessage({ type: TypeMessageEnhancement.ERROR, className: 'error-message-animate', value: t('❌ Ocurrió un problema al mejorar el contenido. Inténtalo nuevamente.') });
    } finally {
      setLoading(false);
    }
  };

  const resetToOriginal = () => {
    setWasGenerated(false);
    setMessage({ type: TypeMessageEnhancement.RESET, className: 'reset-message-animate', value: t('🔄 Los datos han sido restablecidos a su estado original.') });
    return originalData;
  };

  const clearMessage = () => {
    setMessage(null);
  };

  const showMessage = (payload: MessageEnhancement) => {
    setMessage(null);
    setTimeout(() => {
      setMessage(payload);
    }, 0);
  };
  return {
    loading,
    wasGenerated,
    message,
    generateEnhancement,
    resetToOriginal,
    showMessage,
    clearMessage,
  };
}
